module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/fog-ea6115413b451ac5cb57d7d923796480.svg";